export default "__VITE_ASSET__B9136MzU__"